import { render, staticRenderFns } from "./cashback-banner.vue?vue&type=template&id=0f998840&scoped=true&lang=pug&"
import script from "./cashback-banner.vue?vue&type=script&lang=js&"
export * from "./cashback-banner.vue?vue&type=script&lang=js&"
import style0 from "./cashback-banner.vue?vue&type=style&index=0&id=0f998840&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f998840",
  null
  
)

export default component.exports